module.exports = __webpack_public_path__ + "static/media/universal_logo.b02d8c2c.jpg";